import { render, staticRenderFns } from "./WorkTaskRequestApprovalDialog.vue?vue&type=template&id=3b0b5125"
import script from "./WorkTaskRequestApprovalDialog.vue?vue&type=script&lang=ts"
export * from "./WorkTaskRequestApprovalDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports